module.exports = __webpack_public_path__ + "img/dsci0073.d5f38098.jpg";